module.exports = __webpack_public_path__ + "static/media/star-inactive.f41fe0cb.svg";